<template>
  <!-- Family Info Modal -->
  <v-dialog v-model="modalDialog" max-width="725px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Bank Information</h5>
        <button type="button" class="close" @click="method(null)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="postBank">
          <div class="form-scroll">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Bank Information</h3>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Account Number
                        <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        v-model="bankAccountNumber"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Bank Name <span class="text-danger">*</span></label
                      >
                      <select class="form-control" v-model="bank">
                        <option>Select Bank</option>
                        <option
                          v-for="item in banks"
                          :key="item.lookupValue"
                          :value="item.lookupDescription"
                        >
                          {{ item.lookupDescription }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                    <div class="form-group">
                      <label
                        >Bank Verification Number
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        v-model.trim="$v.bvnNumber.$model"
                        type="text"
                      />
                    </div>
                    <div
                      v-if="submitted && !$v.bvnNumber.required"
                      class="invalid-feedback"
                    >
                      Bank Verification Number is required
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary submit-btn" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Family Info Modal -->
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
export default {
  props: {
    model: {},
    id: 0,
    dialog: Boolean,
    method: { type: Function }
  },
  data() {
    return {
      modalDialog: this.dialog,
      employee: null,
      employeeId: this.id,
      bankAccountNumber: this.model ? this.model.bankAccountNumber : "",
      bank: "",
      bankName: this.model ? this.model.bankName : "",
      bankCode: this.model ? this.model.bankCode : "",
      bvnNumber: this.model ? this.model.bvnNumber : "",
      error: "",
      message: "",
      banks: [],
      submitted: false
    };
  },
  validations: {
    bankAccountNumber: { required }
    // bvnNumber: { required }
  },
  mounted() {
    this.getBanks();
    this.$emit("update:employee", this.employee);
    this.$emit("update:bankInfoDialog", this.dialog);
    console.log(model)
  },
  methods: {
    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    postBank() {
      this.submitted = true;
      // console.log(this.Id)
      // stop here if form is invalid
      console.log(this.model);
      console.log(this.bankAccountNumber, this.bank, this.bvnNumber);

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.model) {
        console.log(this.model);
        let id = this.model.id;
        employeeService
          .updateEmployeeBank(
            // this.model.id,
            // this.employeeId,
            // this.bankAccountNumber,
            // this.bank.bankCode,
            // this.bank.bankName,
            // this.bvnNumber
            id,
            this.model
          )
          .then(
            model => {
              this.message = "Bank Info update successfully!";
              employeeService.getEmployeeDetail(this.employeeId).then(
                model => {
                  this.employee = model;
                  if (!this.employee.employeePension) {
                    this.employee.employeePension = {
                      id: 0,
                      pensionNo: "",
                      employeeRate: 0,
                      pensionManager: ""
                    };
                  }
                  if (!this.employee.employeeStatutory) {
                    this.employee.employeeStatutory = {
                      id: 0,
                      salaryBasis: "",
                      salaryAmount: 0.0
                    };
                  }
                  if (!this.employee.employeeTax) {
                    this.employee.employeeTax = {
                      id: 0,
                      tin: "",
                      taxCode: "",
                      taxOffice: "",
                      tax: {}
                    };
                  } else {
                    this.employee.employeeTax.tax = {
                      taxOffice: this.employee.employeeTax.taxCode,
                      description: this.employee.employeeTax.taxOffice
                    };
                  }
                  this.method(this.employee);
                },
                error => {
                  this.error = error;
                }
              );
            },
            error => {
              this.error = error;
            }
          );
      } else {
        employeeService
          .addEmployeeBank(
            this.employeeId,
            this.bankAccountNumber,
            (this.bankCode = this.bank.lookupValue),
            this.bank,
            this.bvnNumber
          )
          .then(
            model => {
              this.message = "Bank Info create successfully!";
              this.method();
              employeeService.getEmployeeDetail(this.employeeId).then(
                model => {
                  this.employee = model;
                  if (!this.employee.passportPhoto) {
                    this.employee.passportPhoto =
                      "../../assets/profiles/avatar-02.jpg";
                  }
                  if (!this.employee.employeePension) {
                    this.employee.employeePension = {
                      id: 0,
                      pensionNo: "",
                      employeeRate: 0,
                      pensionManager: ""
                    };
                  }
                  if (!this.employee.employeeStatutory) {
                    this.employee.employeeStatutory = {
                      id: 0,
                      salaryBasis: "",
                      salaryAmount: 0.0
                    };
                  }
                  if (!this.employee.employeeTax) {
                    this.employee.employeeTax = {
                      id: 0,
                      tin: "",
                      taxCode: "",
                      taxOffice: "",
                      tax: {}
                    };
                  } else {
                    this.employee.employeeTax.tax = {
                      taxOffice: this.employee.employeeTax.taxCode,
                      description: this.employee.employeeTax.taxOffice
                    };
                  }
                },
                error => {
                  this.error = error;
                }
              );
            },
            error => {
              this.error = error;
            }
          );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/employees/BankInfoModal.vue